<list-template>

	<div class="col-12" ngProjectAs="search-toggle">
		<h2 data-testid="SUBSYS2_LIST_SEARCH_TOGGLE" class="search-toggle" [class.active]="!isFiltersCollapsed"
			(click)="isFiltersCollapsed = !isFiltersCollapsed" (keypress)="isFiltersCollapsed = !isFiltersCollapsed">
			{{ labels().FILTERS_COMPONENT_TITLE }}
			<span class="material-icons ms-3">expand_more</span>
		</h2>
	</div>

	<div data-testid="SUBSYS2_LIST_SEARCH_BOX" class="search-sidebar order-xl-1 order-1 col-xxl-2 col-xl-3"
		[ngbCollapse]="isFiltersCollapsed" (hidden)="updateCollapsed(true)" (shown)="updateCollapsed(false)">
		<filters />
	</div>

	<div class="order-xl-2 order-2 col-xl">
		<router-outlet />
	</div>

</list-template>